import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface FiltersInformation {
    filtersInformation: {
        transportModes: Array<any>;
        categories: Array<any>;
        motorized: Array<any>;
        agencies: Array<any>;
    }
}

const initialState : FiltersInformation = {
    filtersInformation: {
        transportModes: [],
        categories: [],
        motorized: [],
        agencies: [],
    },
};

export const filtersSlice = createSlice({
    name: 'filtersSlice',
    initialState,
    reducers: {
        updateModes: (state, action) => {
            state.filtersInformation.transportModes = action.payload;
        },
        updateCategories: (state, action) => {
            state.filtersInformation.categories = action.payload;
        },
        updateMotorized: (state, action) => {
            state.filtersInformation.motorized = action.payload;
        },
        updateOperators: (state, action) => {
            state.filtersInformation.agencies = action.payload;
        },
        reset: (state) => {
            state.filtersInformation = {
                transportModes: [],
                categories: [],
                motorized: [],
                agencies: [],
            };
        },
    },
});

export const { reset, updateOperators, updateMotorized, updateCategories, updateModes } = filtersSlice.actions;


export const filtersState = (state: RootState) => state.filters.filtersInformation;

export default filtersSlice.reducer;
